<template>
  <v-dialog v-model="dialog" width="700px">
    <v-card v-if="ready === true">
      <p class=".title ma-2">Sales partner adjustment</p>
      <v-form ref="huovInpt" v-model="huovInptValid">
        <v-row no-gutters>
            
          <v-col cols="6" class="px-1">
           <v-autocomplete v-model="huov.inpt_code" :items="inpt_codeKeuzes" menu-props="auto" item-value="inpt_code" item-text="inpt_naam" label="Sales web partner"></v-autocomplete>
          </v-col> 
        </v-row>

        <v-row no-gutters>
            <v-col cols="6" class="px-1">
             <v-text-field v-model="huov.eign_code_sales_partner" label="Sales Host partner ID"></v-text-field>
            </v-col> 
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="px-1">
             <v-text-field v-model="huov.huov_ota_code" label="Sales Partner reservation number"></v-text-field>
            </v-col> 
          </v-row>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary mx-2"
          small
          @click="updInpt"
          :disabled="!huovInptValid"
          >Save</v-btn
        >
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huovInptValid: false,
      ready: false,
      inpt_codeKeuzes: [],
      huov: {}
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovInpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovInpt",
          },
          getHuovInpt: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovInpt;
            res.data.getHuovInpt.inpt_codeKeuzes.forEach(function (inpt) {
              deze.inpt_codeKeuzes.push(inpt);
            });
            this.ready = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updInpt() {
      this.$axios
        .post("ares/json/ares/huov/updInpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updInpt",
          },
          updInpt: {
            huov_encrid: this.huov.huov_encrid,
            inpt_code: this.huov.inpt_code,
            eign_code_sales_partner: this.huov.eign_code_sales_partner,
            huov_ota_code: this.huov.huov_ota_code,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updInpt.text,
              color: res.data.updInpt.color,
            });
            if (res.data.updInpt.color == "success" || res.data.updInpt.color == "warning" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.updInpt.huov_encrid); }, 1000); 
            }
            this.dialog = false;
          }
        });
    },
  }
  
};
</script>

